import React, { useState, useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../../api/mockData";

export default function Auth() {
  const nav = useNavigate();
  const loc = useLocation();
  const [loading, setLoading] = useState(false);
  const [scale, setScale] = useState(1);

  // 响应式缩放功能
  useEffect(() => {
    // 计算并设置初始缩放比例
    const calculateScale = () => {
      const screenWidth = window.innerWidth;
      // 当屏幕宽度小于375px时，开始进行缩放
      if (screenWidth < 375) {
        // 计算缩放比例，确保最小缩放为0.8
        const newScale = Math.max(screenWidth / 375, 0.8);
        setScale(newScale);
      } else {
        setScale(1);
      }
    };

    // 初始化时计算一次
    calculateScale();

    // 添加窗口大小变化监听器
    window.addEventListener("resize", calculateScale);

    // 组件卸载时移除监听器
    return () => {
      window.removeEventListener("resize", calculateScale);
    };
  }, []);

  const onFinish = async (vals) => {
    setLoading(true);
    try {
      const result = await login(vals);
      if (result.success) {
        message.success("登录成功");
        const to = loc.state?.from || "/";
        nav(to);
      } else {
        message.error(result.message);
      }
    } catch (error) {
      message.error("登录失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: "20px", 
      maxWidth: "360px", 
      margin: "0 auto",
      width: "100%",
      boxSizing: "border-box",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // 添加响应式缩放
      transform: `scale(${scale})`,
      transformOrigin: "center top",
      transition: "transform 0.3s ease-in-out"
    }}>
      <div className="card-glow" style={{ 
        padding: "24px 20px", 
        borderRadius: "8px",
        background: "var(--theme-card-bg)",
        backdropFilter: "blur(10px)",
        border: "1px solid var(--theme-card-border)",
        width: "100%",
        maxWidth: "100%"
      }}>
        <div className="page-title" style={{ 
          textAlign: "center", 
          marginBottom: "20px",
          fontSize: "22px",
          fontWeight: "bold",
          color: "var(--theme-text)"
        }}>
          登录
        </div>
        <Form 
          layout="vertical" 
          onFinish={onFinish} 
          style={{ width: "100%" }}
        >
          <Form.Item 
            label={<span style={{ color: 'var(--theme-text)' }}>用户名</span>}
            name="username" 
            rules={[{ required: true, message: "请输入用户名" }]}
            style={{ marginBottom: "16px" }}
          >
            <Input 
              size="large"
              style={{ 
                width: "100%", 
                maxWidth: "100%",
                boxSizing: "border-box",
                color: "var(--theme-text)",
                border: "1px solid var(--theme-card-border)",
                background: "rgba(255, 255, 255, 0.05)"
              }}
              placeholder="请输入用户名"
            />
          </Form.Item>
          <Form.Item 
            label={<span style={{ color: 'var(--theme-text)' }}>密码</span>}
            name="password" 
            rules={[{ required: true, message: "请输入密码" }]}
            style={{ marginBottom: "20px" }}
          >
            <Input.Password 
              size="large"
              style={{ 
                width: "100%", 
                maxWidth: "100%",
                boxSizing: "border-box",
                color: "var(--theme-text)",
                border: "1px solid var(--theme-card-border)",
                background: "var(--theme-card-bg)"
              }}
              placeholder="请输入密码"
            />
          </Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={loading} 
            block 
            size="large"
            style={{ 
              height: "40px",
              fontSize: "16px",
              background: "var(--theme-primary)",
              border: "none"
            }}
          >
            登录
          </Button>
        </Form>
        <div className="muted" style={{ 
          marginTop: "16px", 
          textAlign: "center",
          fontSize: "12px",
          color: "var(--theme-text)",
          opacity: 0.7,
          lineHeight: "1.4"
        }}>
          用户名：惜哉剑气疏，密码：123456
        </div>
      </div>
    </div>
  );
}